//@author: devin
import { ChangeDetectionStrategy, Component, Input, NgZone, OnInit, ViewEncapsulation } from "@angular/core";
import { DropDownItem } from "../../../pojo/DropDownItem";
import { SearchCriteriaService } from "../../../services/search/search-criteria/search.criteria.service";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";

@TypeManagerDecorator("s25-event-type-dropdown")
@Component({
    selector: "s25-event-type-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [items]="items"
                [value]="value()"
                [onSelect]="onSelect"
                [searchEnabled]="true"
                [hasFav]="true"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [focusFirst]="focusFirst"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [apiBean]="apiBean"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                [placeholder]="'Select from Types'"
                [searchPlaceholder]="'Filter Event Types'"
                [ariaLabel]="ariaLabel"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25EventTypeDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() formTypesOnly: boolean;
    constructor(private zone: NgZone) {
        super();
    }

    ngOnInit() {
        const value = this.value();
        if (value) {
            value.itemTypeId = 7;
        }
        //if useSecurity is set, list of event types is filtered to those allowed by rose config and preference config (used for writing new event type)
        SearchCriteriaService.getEventTypes(
            S25Util.toBool(this.useSecurity),
            S25Util.toBool(this.activeOnly),
            S25Util.toBool(this.formTypesOnly),
        ).then((data: DropDownItem[]) => {
            this.zone.run(() => {
                this.staticItems = data.filter((obj: DropDownItem) => {
                    return obj.favorite === "T";
                });
                this.items = data;
                this.onLoad && this.onLoad();
            });
        });
    }
}
